import { Patient } from '@dreryk/egabinet-patient-frontend-api';
import { IdentityDocument } from '@dreryk/egabinet-patient-published-language-api';
import { VisitPatient } from '@dreryk/egabinet-visit-frontend-api';

import { StyledFlex } from '@dreryk/react-components';

import { PatientPersonalDataText } from '../../PatientPersonalDataText';

import { PassportIdentityDocumentEditLink } from './edit/PassportIdentityDocumentEditLink';
import { PassportIdentityDocumentEnterLink } from './enter/PassportIdentityDocumentEnterLink';

const hasIdentityDocument = (identityDocument: IdentityDocument | undefined): identityDocument is IdentityDocument => {
   return Boolean(identityDocument);
};

const isPassportIdentityDocumentType = (
   identityDocument: IdentityDocument | undefined
): identityDocument is IdentityDocument => {
   return hasIdentityDocument(identityDocument) && identityDocument.getType() === 'PASSPORT';
};

type PassportIdentityDocumentProps = {
   readonly patient: VisitPatient;
   readonly identityDocument: IdentityDocument | undefined;
   readonly onIdentityDocumentChanged: (patient: Patient) => Promise<void> | void;
};

export const PassportIdentityDocument = (props: PassportIdentityDocumentProps): JSX.Element => {
   if (isPassportIdentityDocumentType(props.identityDocument)) {
      return (
         <StyledFlex direction={'column'} gap={'8px'}>
            <PatientPersonalDataText patient={props.patient} />
            <PassportIdentityDocumentEditLink
               patientId={props.patient.id}
               identityDocument={props.identityDocument}
               onIdentityDocumentUpdated={props.onIdentityDocumentChanged}
            />
         </StyledFlex>
      );
   }

   return (
      <StyledFlex direction={'row'} gap={'24px'} alignItems={'center'}>
         <PatientPersonalDataText patient={props.patient} />
         <PassportIdentityDocumentEnterLink
            patientId={props.patient.id}
            hasAnotherIdentityDocument={hasIdentityDocument(props.identityDocument)}
            onIdentityDocumentChanged={props.onIdentityDocumentChanged}
         />
      </StyledFlex>
   );
};
